import Component from "@ember/component";

export default Component.extend({
  classNames: ["tap-tile-grid"],
  activeTile: null,
});
